export const WORKGROUPDETAIL_LOADING = "WORKGROUPDETAIL_LOADING";
export const WORKGROUPDETAIL_RESET = "WORKGROUPDETAIL_RESET";
export const GET_WORKGROUPDETAIL = "GET_WORKGROUPDETAIL";
export const GET_WORKGROUPDETAIL_SUCCESS = "GET_WORKGROUPDETAIL_SUCCESS";
export const GET_WORKGROUPDETAIL_FAIL = "GET_WORKGROUPDETAIL_FAIL";
export const DELETE_WORKGROUPDETAIL = "DELETE_WORKGROUPDETAIL"
export const DELETE_WORKGROUPDETAIL_SUCCESS = "DELETE_WORKGROUPDETAIL_SUCCESS"
export const DELETE_WORKGROUPDETAIL_FAIL = "DELETE_WORKGROUPDETAIL_FAIL"
export const UPDATE_WORKGROUPDETAIL = "UPDATE_WORKGROUPDETAIL"
export const UPDATE_WORKGROUPDETAIL_SUCCESS = "UPDATE_WORKGROUPDETAIL_SUCCESS"
export const UPDATE_WORKGROUPDETAIL_FAIL = "UPDATE_WORKGROUPDETAIL_FAIL"
export const ADD_NEW_WORKGROUPDETAIL = "ADD_NEW_WORKGROUPDETAIL"
export const ADD_WORKGROUPDETAIL_SUCCESS = "ADD_WORKGROUPDETAIL_SUCCESS"
export const ADD_WORKGROUPDETAIL_FAIL = "ADD_WORKGROUPDETAIL_FAIL"